import { useRef } from 'react';
import { Outlet } from 'react-router-dom';

import { cn } from '../../utils/cn';
import { MobileTopBar } from './MobileTopBar';
import { DesktopTopBar } from './DesktopTopBar';
import { BottomNav } from './BottomNav';
import { Sidebar } from './Sidebar';
import { ScrollContainerProvider } from './ScrollContainerContext';
import { ScrollToTop } from './ScrollToTop';
import { QuickExpenseSheet } from '../expenses/QuickExpenseSheet';
import { GlobalQuickIncomeSheet } from '../income/GlobalQuickIncomeSheet';
import { QuickCategorySheet } from '../quickCreate/QuickCategorySheet';
import { QuickAssetSheet } from '../quickCreate/QuickAssetSheet';
import { QuickGoalSheet } from '../quickCreate/QuickGoalSheet';
import { ExpenseSheetProvider } from '../../features/expenses/SheetProvider';
import { IncomeSheetProvider } from '../../features/income/SheetProvider';
import {
  AssetSheetProvider,
  CategorySheetProvider,
  GoalSheetProvider,
} from '../../features/quickCreate/SheetProviders';
import { SelfieCycleProvider } from '../../store/SelfieCycleContext';
import { EvolutionAiProvider } from '../../store/EvolutionAiContext';
import { EvolutionAiDrawer } from '../ai/EvolutionAiDrawer';
import { MobilePageHeaderProvider } from '../../store/MobilePageHeaderContext';
import { MOBILE_MAIN_PADDING_CLASS } from './mobileLayoutConstants';

/**
 * AppLayout mobile-first:
 * - <md: MobileTopBar + main scrollável + BottomNav
 * - md+: Sidebar (rail / labels) + DesktopTopBar + main scrollável
 * - Quick sheets em todas as rotas autenticadas.
 */
export function AppLayout() {
  const mainRef = useRef(null);

  return (
    <ExpenseSheetProvider>
      <IncomeSheetProvider>
        <CategorySheetProvider>
          <AssetSheetProvider>
            <GoalSheetProvider>
                <SelfieCycleProvider>
                  <EvolutionAiProvider>
                    <MobilePageHeaderProvider>
                      <ScrollContainerProvider value={mainRef}>
                        <ScrollToTop />
                        <div className="flex min-h-screen w-full min-w-0 bg-background md:h-screen md:max-h-screen md:overflow-hidden">
                          <Sidebar />
                          <div className="flex h-[100dvh] min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden md:h-full">
                            <div className="md:hidden">
                              <MobileTopBar />
                            </div>
                            <DesktopTopBar />
                            <main
                              ref={mainRef}
                              className={cn(
                                'min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain pt-14 md:pb-0 md:pt-0',
                                MOBILE_MAIN_PADDING_CLASS,
                              )}
                            >
                              <div className="container-app py-6 md:py-5 lg:px-6 lg:py-6">
                                <Outlet />
                              </div>
                            </main>
                            <BottomNav />
                          </div>
                          <QuickExpenseSheet />
                          <GlobalQuickIncomeSheet />
                          <QuickCategorySheet />
                          <QuickAssetSheet />
                          <QuickGoalSheet />
                          <EvolutionAiDrawer />
                        </div>
                      </ScrollContainerProvider>
                    </MobilePageHeaderProvider>
                  </EvolutionAiProvider>
                </SelfieCycleProvider>
              </GoalSheetProvider>
            </AssetSheetProvider>
          </CategorySheetProvider>
      </IncomeSheetProvider>
    </ExpenseSheetProvider>
  );
}
